import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ImageCaptureInputComponent } from './image-capture-input/image-capture-input.component';
import {ImageCaptureComponent} from './image-capture/image-capture.component';
import {MatButtonModule} from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {CommonModule} from '@angular/common';
import { ImageCaptureUnicoComponent } from './image-capture-unico/image-capture-unico.component';
import { ImageCaptureOitiComponent } from './image-capture-oiti/components/image-capture-oiti/image-capture-oiti.component';
import { ImageCaptureOitiDocumentComponent } from './image-capture-oiti/components/document/image-capture-oiti-document.component';
import { ImageCaptureSerasaComponent } from './image-capture-serasa/image-capture-serasa.component';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { ImageCaptureVsoftComponent } from './image-capture-vsoft/image-capture-vsoft.component';
import { SafeUrlPipe } from '../utils/safe-url';
import { ImageCaptureFortFaceComponent } from './image-capture-fortface/components/image-capture-fortface/image-capture-fortface.component';
import { ImageCaptureFortFaceDocumentComponent } from './image-capture-fortface/components/document/image-capture-fortface-document.component';
import { FortfaceLoaderComponent } from './fortface-loader/fortface-loader.component';
import { ImageCaptureSerasaUnificadoLivenessComponent } from './image-capture-serasa-unificado-liveness/image-capture-serasa-unificado-liveness.component';

const customNotifierOptions: NotifierOptions = {
  position: {
		horizontal: {
			position: 'left',
			distance: 12
		},
		vertical: {
			position: 'top',
			distance: 12,
			gap: 10
		}
	},
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

@NgModule({
  declarations: [
    ImageCaptureInputComponent,
    ImageCaptureComponent,
    ImageCaptureUnicoComponent,
    ImageCaptureOitiComponent,
    ImageCaptureOitiDocumentComponent,
    ImageCaptureVsoftComponent,
    ImageCaptureFortFaceComponent,
    ImageCaptureFortFaceDocumentComponent,
    ImageCaptureSerasaComponent,
    ImageCaptureSerasaUnificadoLivenessComponent,
    SafeUrlPipe,
    // FortfaceLoaderComponent
  ],
  imports: [
    MatButtonModule,
    CommonModule,
    MatProgressSpinnerModule,
    NotifierModule.withConfig(customNotifierOptions)
  ],
  exports: [
    ImageCaptureInputComponent,
    ImageCaptureComponent,
    ImageCaptureUnicoComponent,
    ImageCaptureOitiComponent,
    ImageCaptureSerasaComponent,
    ImageCaptureSerasaUnificadoLivenessComponent,
    ImageCaptureOitiDocumentComponent,
    ImageCaptureFortFaceComponent,
    // FortfaceLoaderComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ImageCaptureInputModule { }
